export const mockPolicyList = {
  data: [
    {
      id: 'a1b2c3d4-1111-4562-b3fc-2c963f66afa1',
      name: 'Agent Registration Policy',
      description: 'Automatically assign owners when new agents are registered',
      domain: 'AGENT_SECURITY',
      isActive: true,
      isCustom: false,
      batchModeEnabled: true,
      triggerType: 'AGENT_REGISTERED',
      conditions: {
        operator: 'AND',
        conditions: [
          {
            field: 'agent.type',
            operator: 'eq',
            value: 'production',
          },
        ],
      },
      actions: [
        {
          type: 'owner_assignment',
          payload: [
            {
              type: 'initial_assignments',
              value: [
                {
                  role: 'primary_owner',
                  rank: 1,
                  assigned_to: {
                    type: 'user',
                    user_id: 'user123',
                    expression: 'MANAGER_OF',
                    params: {
                      source_role: 'creator',
                      source_rank: 1,
                    },
                  },
                },
              ],
              payload: [
                {
                  when: {
                    owner_type: 'primary_owner',
                    rank: 1,
                    condition: 'VACANT',
                  },
                  then: {
                    action: 'PROMOTE_NEXT_LOWER_RANK',
                  },
                },
              ],
            },
          ],
        },
      ],
      createdBy: 'admin@example.com',
      lastUpdatedBy: 'admin@example.com',
      lastUsedTs: 1704067200000,
      createdTs: 1701388800000,
      updatedTs: 1704067200000,
    },
    {
      id: 'b2c3d4e5-2222-4562-b3fc-2c963f66afa2',
      name: 'High Risk Agent Alert',
      description: 'Notify security team for high-risk agent activities',
      domain: 'AGENT_SECURITY',
      isActive: true,
      isCustom: true,
      batchModeEnabled: false,
      triggerType: 'AGENT_REGISTERED',
      conditions: {
        operator: 'AND',
        conditions: [
          {
            field: 'risk.level',
            operator: 'eq',
            value: 'high',
          },
        ],
      },
      actions: [
        {
          type: 'owner_assignment',
          payload: [
            {
              type: 'initial_assignments',
              value: [
                {
                  role: 'security_reviewer',
                  rank: 1,
                  assigned_to: {
                    type: 'user',
                    user_id: 'security_team',
                    expression: 'MANAGER_OF',
                    params: {
                      source_role: 'owner',
                      source_rank: 1,
                    },
                  },
                },
              ],
              payload: [],
            },
          ],
        },
      ],
      createdBy: 'security@example.com',
      lastUpdatedBy: 'security@example.com',
      lastUsedTs: 1704153600000,
      createdTs: 1702598400000,
      updatedTs: 1704153600000,
    },
    {
      id: 'c3d4e5f6-3333-4562-b3fc-2c963f66afa3',
      name: 'Compliance Review Policy',
      description: 'Ensure compliance review for regulated agents',
      domain: 'AGENT_SECURITY',
      isActive: false,
      isCustom: true,
      batchModeEnabled: true,
      triggerType: 'AGENT_REGISTERED',
      conditions: {
        operator: 'AND',
        conditions: [
          {
            field: 'compliance.required',
            operator: 'eq',
            value: 'true',
          },
        ],
      },
      actions: [
        {
          type: 'owner_assignment',
          payload: [
            {
              type: 'initial_assignments',
              value: [
                {
                  role: 'compliance_officer',
                  rank: 2,
                  assigned_to: {
                    type: 'user',
                    user_id: 'compliance_team',
                    expression: 'MANAGER_OF',
                    params: {
                      source_role: 'primary_owner',
                      source_rank: 1,
                    },
                  },
                },
              ],
              payload: [
                {
                  when: {
                    owner_type: 'compliance_officer',
                    rank: 2,
                    condition: 'VACANT',
                  },
                  then: {
                    action: 'PROMOTE_NEXT_LOWER_RANK',
                  },
                },
              ],
            },
          ],
        },
      ],
      createdBy: 'compliance@example.com',
      lastUpdatedBy: 'admin@example.com',
      lastUsedTs: 1703548800000,
      createdTs: 1700697600000,
      updatedTs: 1703548800000,
    },
    {
      id: 'd4e5f6a7-4444-4562-b3fc-2c963f66afa4',
      name: 'Development Agent Policy',
      description: 'Auto-assign development team leads for dev agents',
      domain: 'AGENT_SECURITY',
      isActive: true,
      isCustom: false,
      batchModeEnabled: true,
      triggerType: 'AGENT_REGISTERED',
      conditions: {
        operator: 'AND',
        conditions: [
          {
            field: 'environment',
            operator: 'eq',
            value: 'development',
          },
        ],
      },
      actions: [
        {
          type: 'owner_assignment',
          payload: [
            {
              type: 'initial_assignments',
              value: [
                {
                  role: 'dev_lead',
                  rank: 1,
                  assigned_to: {
                    type: 'user',
                    user_id: 'dev_lead_001',
                    expression: 'MANAGER_OF',
                    params: {
                      source_role: 'developer',
                      source_rank: 1,
                    },
                  },
                },
              ],
              payload: [],
            },
          ],
        },
      ],
      createdBy: 'devops@example.com',
      lastUpdatedBy: 'devops@example.com',
      lastUsedTs: 1704240000000,
      createdTs: 1701993600000,
      updatedTs: 1704240000000,
    },
    {
      id: 'e5f6a7b8-5555-4562-b3fc-2c963f66afa5',
      name: 'Critical Agent Escalation',
      description: 'Escalate critical agents to senior management',
      domain: 'AGENT_SECURITY',
      isActive: true,
      isCustom: true,
      batchModeEnabled: false,
      triggerType: 'AGENT_REGISTERED',
      conditions: {
        operator: 'AND',
        conditions: [
          {
            field: 'priority',
            operator: 'eq',
            value: 'critical',
          },
        ],
      },
      actions: [
        {
          type: 'owner_assignment',
          payload: [
            {
              type: 'initial_assignments',
              value: [
                {
                  role: 'executive_reviewer',
                  rank: 3,
                  assigned_to: {
                    type: 'user',
                    user_id: 'exec_team',
                    expression: 'MANAGER_OF',
                    params: {
                      source_role: 'primary_owner',
                      source_rank: 2,
                    },
                  },
                },
              ],
              payload: [
                {
                  when: {
                    owner_type: 'executive_reviewer',
                    rank: 3,
                    condition: 'VACANT',
                  },
                  then: {
                    action: 'PROMOTE_NEXT_LOWER_RANK',
                  },
                },
              ],
            },
          ],
        },
      ],
      createdBy: 'admin@example.com',
      lastUpdatedBy: 'exec@example.com',
      lastUsedTs: 1704326400000,
      createdTs: 1702080000000,
      updatedTs: 1704326400000,
    },
  ],
  pagination: {
    totalCount: 5,
    limit: 10,
    nextToken: null,
  },
};

export const mockPolicyFilterData = {
  status: {
    options: [
      { id: true, name: 'Active' },
      { id: false, name: 'In-Active' },
    ],
  },
  domain: {
    options: [
      { id: 'AGENT_POSTURE', name: 'Agent Posture' },
      { id: 'AGENT_SECURITY', name: 'Agent Security' },
      { id: 'NHI_POSTURE', name: 'NHI Posture' },
    ],
  },
  type: {
    options: [
      { id: 'all', name: 'All' },
      { id: 'system-defined', name: 'System Defined' },
      { id: 'user-defined', name: 'User Defined' },
    ],
  },
};
